import { render, staticRenderFns } from "./EmployerRegistrationMaintenance.vue?vue&type=template&id=dbbab9b6&"
import script from "./EmployerRegistrationMaintenance.vue?vue&type=script&lang=ts&"
export * from "./EmployerRegistrationMaintenance.vue?vue&type=script&lang=ts&"
import style0 from "./EmployerRegistrationMaintenance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports